import {useState, type FormEvent} from 'react';
import type {HermesState} from './lib/types';
import type {useHermes} from './lib/store';

export function MessagePrefixSettings({state, actions}: {
  state: HermesState; actions: ReturnType<typeof useHermes>['actions'];
}) {
  const [draft, setDraft] = useState<boolean | null>(null);
  const saved = state.accountSettings.data?.messagePrefix;
  const enabled = draft ?? saved?.enabled;
  const busy = state.operation.label !== null || state.accountSettings.status !== 'ready';
  async function save(event: FormEvent): Promise<void> {
    event.preventDefault();
    if (enabled === undefined) return;
    try {await actions.saveMessagePrefix(enabled); setDraft(null);}
    catch { /* Keep the draft. The shared operation notice displays the request error. */ }
  }
  return <section className="settings-section"><div className="settings-description">
    <h2>Automatic message prefix</h2>
    <p>Add the same prefix to messages from chat, WhatsApp, and other connected services.</p>
    <p>This setting is on by default.</p>
  </div>{saved && enabled !== undefined ? <form className="settings-key-form" onSubmit={event => void save(event)}>
    <label className="field"><span>Add <code>{saved.prefix}</code> before every message</span>
      <select value={enabled ? 'on' : 'off'} disabled={busy} onChange={event => setDraft(event.target.value === 'on')}>
        <option value="on">On</option><option value="off">Off</option>
      </select>
    </label>
    <p className="field-help">The prefix is followed by a new line and your message.</p>
    <button className="button" type="submit" disabled={busy || enabled === saved.enabled}>Save message prefix</button>
  </form> : state.accountSettings.status === 'ready' && <p>Start your team to read or change this setting.</p>}</section>;
}
